import { render, staticRenderFns } from "./KpiItem.vue?vue&type=template&id=d456d72e&"
import script from "./KpiItem.vue?vue&type=script&lang=js&"
export * from "./KpiItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports